import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../utils/apiClient";

type AssignAccessRequest = {
  userId: string;
  groupId: number | null;
  airlineIds: number[];
};

const assignAccess = async ({ userId, groupId, airlineIds }: AssignAccessRequest): Promise<void> => {
  await api.patch(`/api/v1/users/${encodeURIComponent(userId)}/access`, {
    json: { groupId, airlineIds },
  });
};

export const useAssignAccessMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: assignAccess,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/v1/users"] });
    },
  });
};
